import { cn } from "@/components/podkit/lib/cn";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="skeleton"
            className={cn("animate-pulse rounded-md dark:bg-surface-tertiary", className)}
            {...props}
        />
    );
}
export { Skeleton };
